// Khởi tạo kết nối đến Supabase
export const supabaseUrl = 'https://bbugmuhbyntjszoalzqu.supabase.co';
export const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJidWdtdWhieW50anN6b2FsenF1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMyODI5NzMsImV4cCI6MjA4ODg1ODk3M30.42_93xlqztQqXWtc7zRejhvcPmkmI2NFTt-WRRnLAyA';

// Lấy client từ CDN (đã load sẵn trong index.html)
export const supabaseClient = window.supabase.createClient(supabaseUrl, supabaseKey);
